import React from "react";
import styled from "styled-components";
import Loading from "sweet-web/components/universal/Loading";
import { Paragraph } from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";

type ButtonProps = {
  color?: string;
  small?: boolean;
};
const StyledButton = styled.button<ButtonProps>`
  padding: ${props => (props.small ? 10 : 15)}px 30px;
  ${props => (props.small ? `` : `width: 100%;`)}
  min-height: 30px;
  background-color: ${props => props.color || colors.primary};
  color: ${colors.white};
  outline: none;
  border: none;
  font-size: 14px;
  font-weight: 700;
  box-shadow: rgba(88, 29, 208, 0.08) 0 5px 10px 0;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  margin: 10px 0;
  border-radius: 5px;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:hover {
    transform: scale(1.03);
  }
`;

type Props = {
  disabled?: boolean;
  loading?: boolean;
  title: string;
  onClick?: (e?: any) => any;
  submit?: boolean;
  style?: object;
  error?: Error;
  small?: boolean;
};
const Button: React.FC<Props> = props => {
  return (
    <React.Fragment>
      <StyledButton
        style={props.style}
        type={props.submit ? "submit" : "button"}
        color={props.disabled ? colors.gray : colors.primary}
        disabled={props.disabled || props.loading}
        onClick={props.onClick}
        small={props.small}
      >
        {props.loading ? (
          <Loading size={20} style={{ alignSelf: "center" }} />
        ) : (
          props.title
        )}
      </StyledButton>
      {props.error && props.error.message && (
        <Paragraph style={{ marginBottom: 10, color: colors.red }}>
          {props.error.message}
        </Paragraph>
      )}
    </React.Fragment>
  );
};
Button.defaultProps = {
  style: {}
};

export default Button;
